<nz-card>

  <div class="row" *userAuthority="['ROLE_ADMIN']">
    <div class="col-2 offset-5 d-flex justify-content-end align-items-center">
      <label for="">Thuế TNCN:</label>
    </div>
    <div class="col-3 ">
      <div class="d-md-flex flex-row">
        <ng-template #nexfixTemplate>
          <i nz-icon nzType="percentage" class="opacity-05" nzTheme="outline"></i>
        </ng-template>
        <nz-input-group [nzSuffix]="nexfixTemplate">
          <input type="text" nz-input [(ngModel)]="setting.value">
        </nz-input-group>
        <button nz-button nzType="primary" style="margin-left: 10px" (click)="confirmUpdateConfig()"
        >Sửa</button>
      </div>
    </div>
  </div>
  <app-search-filter [total]="queryParams.totalItems" (search$)="getValueSearch($event)">
    <div class="col-12 m-b-25">
      <div class="row">
        <div class="d-flex align-items-center">
          <i nz-icon nzType="search" class="opacity-05 mr-2"></i>
        </div>
        <div class="col-lg-3">
          <div class="d-md-flex">
            <nz-input-group>
              <input type="text" nz-input placeholder="Mã sản phẩm" [(ngModel)]="searchParams.code" 
              (ngModelChange)="eventSearchParams('code', searchParams.code)">
            </nz-input-group>
          </div>
        </div>
      </div>
    </div>
  </app-search-filter>

  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
      <tr>
        <th>Tên</th>
        <th>Mã sản phẩm</th>
        <th>NAV</th>
        <th>Tổng giá trị phát hành</th>
        <th>Ngày kết thúc phát hành</th>
        <th>Tổng giá trị</th>
        <th>Chỉ số rủi ro</th>
        <th>Trạng thái</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of list; trackBy: trackId; index as index">
        <td>{{item.name}}</td>
        <td>{{item.code}}</td>
        <td>{{item.nav | money}}</td>
        <td>{{(item.issueValue || 0) | money}}</td>
        <td>{{item.endIssueAt | date}}</td>
        <td>{{item.currentValue | money}}</td>
        <td>{{item.riskNumber | money}}</td>
        <td>{{item?.statusId?.name}}</td>
        <td>
          <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" *userAuthority="['ROLE_ADMIN']">
             <i nz-icon nzType="menu" nzTheme="outline"></i>
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div [ngClass]="(index > list.length - 3) && list.length > 3 && 'dropup'">
          <ul class="dropdown-menu" role="menu" >
            <li *ngIf="item.statusId.code !== 'PRODUCT_ACTIVE'"><a (click)="approve(item.id)" title="Edit" class="ant-btn btn-edit"><i nz-icon nzType="check" nzTheme="outline"></i><span>Duyệt</span></a></li>
            <li><a (click)="edit(item.id)" title="Edit" class="ant-btn btn-edit"><i nz-icon nzType="edit" nzTheme="outline"></i><span>Sửa đổi</span></a></li>
            <li><a (click)="transferFee(item.id, item.shortName)" class="ant-btn btn-edit" title="Transfer fee"><i nz-icon nzType="sync" nzTheme="outline"></i><span>Phí chuyển đổi</span></a>
            <li><a (click)="addNewFee(item)" class="ant-btn btn-edit" title="Transfer fee"><i nz-icon nzType="sync" nzTheme="outline"></i><span>Phí mới</span></a>
            </li>
            <li><a (click)="confirmDelete(item)" *ngIf="item.statusId.code !== 'PRODUCT_HIDDEN'" title="Delete" class="ant-btn btn-edit"><i nz-icon nzType="stop" nzTheme="outline"></i><span>Ẩn</span></a></li>
            <li><a (click)="confirmActive(item)" *ngIf="item.statusId.code === 'PRODUCT_HIDDEN'" title="Delete" class="ant-btn btn-edit"><i nz-icon nzType="check-circle" nzTheme="outline"></i><span>Hiện</span></a></li>
          </ul>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems"
      [nzPageSize]="queryParams.size" [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)">
    </nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>